module.exports = __webpack_public_path__ + "static/img/shopHeaderBg2560.f1c6564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopHeaderBg2560.png
// module id = kYiD
// module chunks = 18